(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemHover = exports.menu = exports.fixedHeader = void 0;

var fixedHeader = function fixedHeader() {
  var header = document.querySelector('.header');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 250) {
      // header.classList.add('header--fixed');
      document.body.classList.add('page-scrolled');
    } else {
      // header.classList.remove('header--fixed');
      document.body.classList.remove('page-scrolled');
    }
  });
};

exports.fixedHeader = fixedHeader;

var menu = function menu() {
  var burger = document.querySelector('[data-burger]');
  burger.addEventListener('click', function () {
    document.body.classList.toggle('nav-active');
  }); // const menuWrapper = document.querySelector('.header__nav__menu');
  // menuWrapper.addEventListener('click', e => {
  //   if (e.target.nodeName == 'A') {
  //     document.body.classList.remove('nav-active');
  //   }
  // });
};

exports.menu = menu;

var menuItemHover = function menuItemHover() {
  var menuItems = document.querySelectorAll('[data-hover-img]');
  var hoverMenuImageVisible = false;

  if (menuItems) {
    menuItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var hoverImgUrl = item.dataset.hoverImg;

        if (hoverImgUrl) {
          if (item.parentElement.parentElement.className == 'menu-menu-first-container') {
            if (!hoverMenuImageVisible) {
              hoverMenuImageVisible = true;
              document.querySelector('.nav__bg__item--first').style.backgroundImage = 'url(' + hoverImgUrl + ')';
              setTimeout(function () {
                document.querySelector('.nav__bg__item--first').style.opacity = 0.4;
              }, 200);
            }
          }
        }
      });
      item.addEventListener('mouseleave', function () {
        document.querySelector('.nav__bg__item--first').style.opacity = 0;
        hoverMenuImageVisible = false;
      });
    });
  }
};

exports.menuItemHover = menuItemHover;

},{}],2:[function(require,module,exports){
"use strict";

var _header = require("./components/header");

(0, _header.menu)();
(0, _header.fixedHeader)();
(0, _header.menuItemHover)();
AOS.init({
  disable: function disable() {
    var maxWidth = 768;
    return window.innerWidth < maxWidth;
  }
});
var scrollToTopButton = document.querySelector('.scroll-to-top');

if (scrollToTopButton) {
  scrollToTopButton.addEventListener('click', function () {
    window.scrollTo(0, 0);
  });
} // load more modules on main LP


if (document.body.classList.contains('page-template-template-foto')) {
  var loadMoreModulesButton = document.querySelector('.load-more-photos');
  var moreModulesWrapper = document.querySelector('.more-modules-wrapper');

  if (loadMoreModulesButton && moreModulesWrapper) {
    loadMoreModulesButton.addEventListener('click', function () {
      loadMoreModulesButton.classList.add('load-more-photos--active');
      moreModulesWrapper.classList.add('more-modules-wrapper--active');
    });
  }
} // load more modules after 10 modules


var showLoadMoreAfterIndex = 9;

if (document.body.classList.contains('page-template-template-foto-flex')) {
  (function () {
    var flexibleContentWrapper = document.querySelector('.flexible-content');

    if (flexibleContentWrapper.children) {
      if (flexibleContentWrapper.children.length > showLoadMoreAfterIndex + 1) {
        var childrenIndex = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = flexibleContentWrapper.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var module = _step.value;

            if (childrenIndex == showLoadMoreAfterIndex) {
              (function () {
                // dodajemy strzałkę
                var loadMoreHtml = "<div class=\"load-more-photos-wrapper\" data-aos=\"fade-up\" data-aos-delay=\"300\">\n            <button class=\"load-more-photos\"><img src=\"/wp-content/themes/dotpro/prod/img/arrow.svg\" alt=\"Load more\"></button>\n          </div>";
                module.insertAdjacentHTML('afterend', loadMoreHtml);
                var loadMoreModulesButton = document.querySelector('.load-more-photos');
                loadMoreModulesButton.addEventListener('click', function () {
                  loadMoreModulesButton.classList.add('load-more-photos--active');
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = flexibleContentWrapper.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var _module = _step2.value;
                      _module.style.visibility = null;
                      _module.style.overflow = null;
                      _module.style.maxHeight = null;
                      _module.style.margin = null;
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                });
              })();
            } else if (childrenIndex > showLoadMoreAfterIndex) {
              // ukrywamy moduły
              if (!module.classList.contains('load-more-photos-wrapper')) {
                module.style.visibility = 'hidden';
                module.style.overflow = 'hidden';
                module.style.maxHeight = 0;
                module.style.margin = 0;
              }
            }

            childrenIndex++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  })();
}

},{"./components/header":1}]},{},[2]);
